import { WebTargetsComponent } from './web-targets.component';
import { ElementCreateComponent } from './element-create';
import { WebTargetsListComponent } from './web-targets-list';


export const routes = [
  { path: '', component: WebTargetsComponent, children: [
    { path: '', redirectTo: 'danh-sach', pathMatch: 'full' },
    { path: 'danh-sach', component: WebTargetsListComponent },
    { path: 'khoi-tao', component: ElementCreateComponent },
  ]},
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/web-targets/web-targets.routes.ts